<template>
  <div>
    <!-- FILTRI CALENDARIO -->
    <v-row class="mt-4 align-center">
      <v-col cols="12" md="3">
        <v-select
            v-model="fieldFilter"
            :items="activeFields"
            item-text="name"
            item-value="_id"
            label="Filtra campi"
            dense
            outlined
            multiple
            chips
            clearable
            small-chips
            hide-details
            deletable-chips
        ></v-select>
      </v-col>

      <v-col cols="12" md="2">
        <v-select
            v-model="sportFilter"
            :items="allSports"
            item-text="name"
            item-value="_id"
            label="Filtra sport"
            dense
            outlined
            multiple
            chips
            clearable
            small-chips
            hide-details
            deletable-chips
        >
          <template v-slot:item="{ item }">
            <img
                v-if="item.icon"
                :src="item.icon"
                width="18"
                class="mr-2"
                :alt="item.name"
            />
            {{ item.name }}
          </template>
        </v-select>
      </v-col>

      <!-- RANGE DATE -->
      <v-col cols="12" md="3">
        <v-menu
            ref="menu_date_search"
            v-model="menu_date_search"
            :return-value.sync="date_search"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dateRangeText"
                label="Intervallo (max 7 giorni)"
                prepend-icon="mdi-calendar"
                append-icon="mdi-close"
                @click:append="resetRange"
                dense
                outlined
                readonly
                v-bind="attrs"
                v-on="on"
                class="date-range-input"
                hide-details
            ></v-text-field>
          </template>

          <v-date-picker
              v-model="date_search"
              range
              scrollable
              no-title
              :first-day-of-week="1"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu_date_search = false">
              Annulla
            </v-btn>
            <v-btn text color="primary" @click="applyCustomRange">
              Ok
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <!-- PULSANTI RANGE RAPIDI -->
      <v-col cols="12" md="4" class="mt-2">
        <div class="d-flex flex-wrap justify-space-between justify-md-end quick-range-wrapper">
          <v-btn small outlined class="mb-2 quick-range-btn" color="primary" @click="setToday">
            Oggi
          </v-btn>
          <v-btn small outlined class="mb-2 quick-range-btn" color="primary" @click="setThreeDays">
            Prossimi 3 giorni
          </v-btn>
          <v-btn small outlined class="mb-2 quick-range-btn" color="primary" @click="setCurrentWeek">
            Settimana corrente
          </v-btn>
          <v-btn small outlined class="mb-2 quick-range-btn" color="primary" @click="setNextWeek">
            Prossima settimana
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-2 align-center">
      <!-- AVVISO NESSUN GIORNO -->
      <v-col cols="12" v-if="selectedDays.length === 0">
        <v-alert type="info" outlined dense>
          Seleziona un giorno o un intervallo (max 7 giorni) per vedere tutti i campi in colonna.
        </v-alert>
      </v-col>

      <!-- LAYOUT 1 SOLO CAMPO VISIBILE: GIORNI IN COLONNE -->
      <template v-if="selectedDays.length > 0 && filteredFields.length === 1">
        <v-col cols="12">
          <v-card class="calendar-full">
            <v-card-title>
              <div class="d-flex align-center flex-wrap">
                  <span class="font-weight-bold mr-3">
                  {{ filteredFields[0].name }}
                  </span>
                  <v-select
                      class="sport-select"
                      v-model="fieldSportSelection[filteredFields[0]._id]"
                      :items="getFieldSports(filteredFields[0]._id)"
                      item-text="name"
                      item-value="_id"
                      dense
                      outlined
                      hide-details
                      label="Sport"
                      :readonly="getFieldSports(filteredFields[0]._id).length === 1"
                      :disabled="getFieldSports(filteredFields[0]._id).length === 1"
                  >
                  <template v-slot:selection="{ item }">
                    <img
                        v-if="item.icon"
                        :src="item.icon"
                        width="16"
                        class="mr-1"
                        :alt="item.name"
                    />
                    {{ item.name }}
                  </template>
                  <template v-slot:item="{ item }">
                    <img
                        v-if="item.icon"
                        :src="item.icon"
                        width="16"
                        class="mr-1"
                        :alt="item.name"
                    />
                    {{ item.name }}
                  </template>
                </v-select>
              </div>
            </v-card-title>

            <v-simple-table fixed-header height="650px">
              <template v-slot:default>
                <thead>
                <tr>
                  <th
                      v-for="dayKey in selectedDays"
                      :key="'head_' + dayKey"
                  >
                    <v-btn color="primary" block small>
                      {{ formatDayTab(dayKey) }}
                    </v-btn>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="row in getMaxSlotsForFieldAcrossDays(filteredFields[0]._id)"
                    :key="'row_' + row"
                >
                  <td
                      v-for="dayKey in selectedDays"
                      :key="dayKey + '_slot_' + row"
                      class="field-col"
                      style="padding: 0 6px;"
                  >
                    <template v-if="getSlot(dayKey, filteredFields[0]._id, row - 1)">
                      <slot-cell
                          :slot-obj="getSlot(dayKey, filteredFields[0]._id, row - 1)"
                          :day-key="dayKey"
                          :field-obj="filteredFields[0]"
                          :get-price="getPrice"
                          :get-availability-now="getAvailabilityNow"
                          :remove-text="removeText"
                          @book="bookNow"
                          @override="overrideSlot"
                      />
                    </template>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </template>

      <!-- LAYOUT 2+ CAMPI VISIBILI: GIORNI COLLASSABILI -->
      <template v-else-if="selectedDays.length > 0 && filteredFields.length >= 2">
        <v-row class="pb-0 pt-0">
          <v-col
              v-for="dayKey in selectedDays"
              :key="dayKey"
              :cols="12"
              :md="filteredFields.length > 3 || selectedDays.length === 1 ? 12 : 6"
              :lg="filteredFields.length > 3 || selectedDays.length === 1 ? 12 : 6"
              class=""
          >
            <v-card class="calendar-full">
              <!-- HEADER COLLASSABILE -->
              <v-card-title
                  class="d-flex align-center justify-space-between"
                  style="cursor: pointer"
                  @click="collapsedDays[dayKey] = !collapsedDays[dayKey]"
              >
                <div>
                  <v-chip color="primary" label text-color="white">
                    {{ formatDayTab(dayKey) }}
                  </v-chip>
                </div>
                <v-btn icon small>
                  <v-icon>
                    {{ collapsedDays[dayKey] ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                  </v-icon>
                </v-btn>
              </v-card-title>

              <v-expand-transition>
                <div v-show="!collapsedDays[dayKey]">
                  <v-simple-table fixed-header height="650px">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th
                            v-for="field in filteredFields"
                            :key="field._id"
                            class="field-col"
                        >
                          <div class="d-flex align-center flex-wrap justify-center">
                            <span class="font-weight-bold" style="flex-wrap: wrap;letter-spacing: 0.0125em;line-height: 2rem;word-break: break-all;color: #1f1b2d">
                              {{ field.name }}
                            </span>

                              <v-select
                                  class="sport-select"
                                  v-model="fieldSportSelection[field._id]"
                                  :items="getFieldSports(field._id)"
                                  item-text="name"
                                  item-value="_id"
                                  dense
                                  outlined
                                  hide-details
                                  label="Sport"
                                  :readonly="getFieldSports(field._id).length === 1"
                                  :disabled="getFieldSports(field._id).length === 1"
                              >
                              </v-select>
                          </div>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          v-for="row in getMaxSlotsForDay(dayKey)"
                          :key="dayKey + '_row_' + row"
                      >
                        <td
                            v-for="field in filteredFields"
                            :key="dayKey + '_' + field._id + '_' + row"
                            class="field-col"
                            style="padding: 0 6px;"
                        >
                          <template v-if="getSlot(dayKey, field._id, row - 1)">
                            <slot-cell
                                :slot-obj="getSlot(dayKey, field._id, row - 1)"
                                :day-key="dayKey"
                                :field-obj="field"
                                :get-price="getPrice"
                                :get-availability-now="getAvailabilityNow"
                                :remove-text="removeText"
                                @book="bookNow"
                                @override="overrideSlot"
                            />
                          </template>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <!-- Nessun campo filtrato ma giorni selezionati -->
      <v-col cols="12" v-else-if="selectedDays.length > 0 && filteredFields.length === 0">
        <v-alert type="info" outlined dense>
          Non ci sono campi visibili con i filtri selezionati.
        </v-alert>
      </v-col>

      <ModalCheckout @message="refresh"/>

      <!-- DIALOG PROMO / OVERRIDE -->
      <v-dialog v-model="dialog_promo" persistent max-width="800px" v-if="slot_to_override">
        <v-card>
          <v-card-title>
            <span class="font-weight-bold">{{ override_title }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <template>
                  <v-flex md12 xs12 class="d-flex">
                    <v-chip color="primary" label small text-color="white">{{ $t('status') }}</v-chip>
                  </v-flex>
                  <v-flex md12 xs12 class="d-flex mt-2 mb-2">
                    <v-checkbox dense hide-details v-model="slot_to_override.status_slot"
                                :label="(slot_to_override.status_slot) ? this.$t('enabled') : this.$t('disabled')"
                                style="margin-top: 0">
                    </v-checkbox>
                  </v-flex>

                  <v-flex md12 xs12 class="d-flex">
                    <v-chip color="primary" label small text-color="white">{{ $t('splitPayment') }}
                    </v-chip>
                  </v-flex>
                  <v-flex md12 xs12 class="d-flex mt-2 mb-2">
                    <v-checkbox dense hide-details v-model="slot_to_override.split_payment_custom"
                                :label="this.$t('enableSplitPaymentCustom')" style="margin-top: 0">
                    </v-checkbox>
                  </v-flex>

                  <template v-if="slot_to_override.split_payment_custom">
                    <v-flex xs12 md4 class="pl-4 pr-4">
                      <v-select :items="split_payment_types" :label="$t('mode')"
                                @change="applySplitOverride"
                                v-model="split_payment_override_selected"></v-select>
                    </v-flex>
                    <v-flex xs12 md4 class="pl-4 pr-4">
                      <v-text-field type="number" :label="$t('onlinePercentage')"
                                    v-model="slot_to_override.split_payment.online_percentage"
                                    prefix="%" step="1"
                                    @input="changePercentageOverride('online')" min="0"
                                    max="100"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 class="pl-4 pr-4">
                      <v-text-field type="number" :label="$t('centerPercentage')"
                                    v-model="slot_to_override.split_payment.center_percentage"
                                    prefix="%" step="1"
                                    @input="changePercentageOverride('center')" min="0"
                                    max="100"></v-text-field>
                    </v-flex>
                  </template>

                  <v-flex xs12 md12 class="d-flex">
                    <v-chip color="primary" label small text-color="white">{{ $tc('promotion') }}
                    </v-chip>
                  </v-flex>
                  <v-flex xs12 md12 class="d-flex mt-2 mb-2">
                    <v-checkbox dense hide-details v-model="slot_to_override.promo_custom"
                                :label="this.$t('enablePromoCustom')" style="margin-top: 0"
                                @change="changePromoCustom">
                    </v-checkbox>
                  </v-flex>
                  <template v-if="slot_to_override.promo_custom">
                    <v-flex xs12 md4 class="pl-4 pr-4">
                      <v-select :items="promotion_types" :label="$t('mode')"
                                v-model="slot_to_override.promo.type"
                                @change="calculateTotalsOverride"></v-select>
                    </v-flex>
                    <v-flex xs12 md4 class="pl-4 pr-4" v-if="slot_to_override.promo.type !== null">
                      <v-text-field type="number" :label="$t('value')"
                                    v-model="slot_to_override.promo.value"
                                    :prefix="(slot_to_override.promo.type === 'fixed') ? '-':'%'"
                                    step="1"
                                    @input="calculateTotalsOverride" min="0" max="100"></v-text-field>
                    </v-flex>
                  </template>

                  <v-flex md12 class="d-flex pt-5">
                    <v-chip color="primary" label small text-color="white">
                      {{ $t('settings') }} {{ $t('PromoCode') }}
                    </v-chip>
                  </v-flex>

                  <v-flex md6 class="pr-4">
                    <v-checkbox
                        v-model="slot_to_override.enable_promo_code_promo_sa_global"
                        label="Accetta Promo Code uCamp"
                        :readonly="!this.getUser.super_admin"
                        :disabled="!this.getUser.super_admin"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex md6 class="pl-4 pr-4">
                    <v-checkbox
                        v-model="slot_to_override.enable_promo_code_promo_center"
                        label="Accetta Promo Code Centro"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 md12 class="d-flex">
                    <v-chip color="primary" label small text-color="white">{{ $t('preview') }}</v-chip>
                  </v-flex>

                  <v-flex xs12 md12 class="pl-4 pr-4 pb-3">
                    <v-simple-table dense>
                      <thead>
                      <tr>
                        <th class="text-left">Sport</th>
                        <th class="text-left">Da Pagare Online</th>
                        <th class="text-left">Da Pagare al Campo</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="preview_ov in preview_price_override"
                          :key="'preview_ov_'+preview_ov.sport_id">
                        <td class="font-weight-bold">{{ getSportName(preview_ov.sport_id) }}</td>
                        <td>
                          <span v-bind:style="[+preview_ov.value_ac < minPriceLimit ? { color: 'red' } : {}]">
                            <template v-if="+preview_ov.value_ac < minPriceLimit">*</template>
                            {{ preview_ov.value_ac.toFixed(2) }} €
                          </span>
                        </td>
                        <td>{{ preview_ov.value_ce.toFixed(2) }} €</td>
                      </tr>
                      </tbody>
                    </v-simple-table>
                    <small style="color: red">* Al di sotto del minimo costo garantito</small>

                  </v-flex>

                </template>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="buttons-group-mobile">
            <v-btn color="secondary" text @click="dialog_promo = false">
              {{ $t('cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="deletePromotion()" v-if="slot_to_override.id !== ''">
              {{ $t('delete') }}
            </v-btn>
            <v-btn color="primary" @click="updatePromotion()" v-if="slot_to_override.id !== ''">
              {{ $t('save') }}
            </v-btn>
            <v-btn color="primary" @click="savePromotion()" v-if="slot_to_override.id === ''">
              {{ $t('insert') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';
import ModalCheckout from "@/components/admin/Checkout";
import SlotCell from "@/components/calendar/SlotCell.vue";

export default {
  name: "CenterDailyCalendar",
  components: { ModalCheckout, SlotCell },
  props: {
    centerId: { type: String, required: true },
    fields: { type: Array, required: true }, // fields_complete_list
  },
  data() {
    return {
      center: null,
      activeFields: [],
      centerCalendar: {},   // { [dayKey]: { date, slotsByField: { [fieldId]: [slots] } } }
      maxSlotsByDay: {},    // { [dayKey]: number }

      date_search: [],
      menu_date_search: false,
      selectedDays: [],
      collapsedDays: {},

      fieldFilter: [],
      sportFilter: [],

      fieldSports: {},          // { [fieldId]: [sports] }
      fieldSportSelection: {},  // { [fieldId]: sportId }

      // override / promo / checkout context
      field: null,
      sport_selected: null,
      slot_selected: '',
      override_title: '',
      slot_to_override: null,
      dialog_promo: false,
      preview_price: [],
      preview_price_override: [],
      split_payment_types: [
        { text: this.$t('payDivide'), value: 'pay_divide' },
        { text: this.$t('payCenter'), value: 'pay_center' },
        { text: this.$t('payOnline'), value: 'pay_online' }
      ],
      promotion_types: [
        { text: '', value: null },
        { text: this.$t('fixed'), value: 'fixed' },
        { text: this.$t('percentage'), value: 'percentage' },
      ],
      split_payment_override_selected: '',
      promotions_active: [],
      sports: [],
    };
  },
  computed: {
    ...mapGetters({
      getEndpoint: 'settings/getEndpoint',
      getUser: 'user/getUser',
    }),
    dateRangeText() {
      if (!this.date_search[0] || !this.date_search[1]) return '';
      return `${this.formatDateHuman(this.date_search[0])} ~ ${this.formatDateHuman(this.date_search[1])}`;
    },
    allSports() {
      const map = {};
      this.activeFields.forEach(f => {
        const list = this.getFieldSports(f._id);
        list.forEach(s => {
          if (!map[s._id]) {
            map[s._id] = { _id: s._id, name: s.name, icon: s.icon || null };
          }
        });
      });
      return Object.values(map);
    },
    filteredFields() {
      let list = this.activeFields;

      if (this.fieldFilter && this.fieldFilter.length) {
        list = list.filter(f => this.fieldFilter.includes(f._id));
      }

      if (this.sportFilter && this.sportFilter.length) {
        list = list.filter(f => {
          const fs = this.getFieldSports(f._id);
          return fs.some(s => this.sportFilter.includes(s._id));
        });
      }

      return list;
    },
    minPriceLimit() {
      if (this.field && this.field.rules && typeof this.field.rules.min_price !== 'undefined') {
        return +this.field.rules.min_price;
      }
      return 0; // fallback: nessun minimo → niente rosso
    }
  },
  watch: {
    fields: {
      immediate: true,
      deep: true,
      async handler(newVal) {
        if (!newVal || !newVal.length) return;
        this.activeFields = newVal.filter(f => f.active);

        this.activeFields.forEach(f => {
          const baseSports = (f.sports || f.sports_info || []).map(s => ({
            _id: s._id || s.name,
            name: s.name,
            icon: s.icon || null
          }));
          this.$set(this.fieldSports, f._id, baseSports);
        });

        if (!this.selectedDays.length) {
          await this.setToday();
        } else {
          await this.loadCenterCalendar();
        }
      }
    },
    centerId: {
      immediate: true,
      async handler(newVal) {
        if (!newVal) return;
        if (this.selectedDays.length && this.activeFields.length) {
          await this.loadCenterCalendar();
        }
      }
    },
    selectedDays(newDays) {
      const state = {};
      newDays.forEach(d => { state[d] = false; }); // false = aperto
      this.collapsedDays = state;
    }
  },
  methods: {
    ...mapMutations({
      setLoading: 'settings/setLoading',
      setNotification: 'settings/setNotification',
    }),
    ...mapActions({
      fetchCalendar: 'bookings/fetchCalendar',
      setDialogCheckout: 'checkout/setDialogCheckout',
      setBooking: 'checkout/setBooking',
      setBookingOriginal: 'checkout/setBookingOriginal',
      storePromotion: 'promotions/store',
      updatePromo: 'promotions/update',
      deletePromo: 'promotions/delete',
      getActivePromotions: 'promotions/getActivePromotions',
    }),

    // RANGE / DATE
    async setToday() {
      const today = new Date().toISOString().split('T')[0];
      this.date_search = [today, today];
      await this.buildDaysFromRange();
    },
    async setThreeDays() {
      const start = new Date();
      const end = new Date();
      end.setDate(end.getDate() + 2);
      this.date_search = [
        start.toISOString().split('T')[0],
        end.toISOString().split('T')[0]
      ];
      await this.buildDaysFromRange();
    },
    async setCurrentWeek() {
      const today = new Date();
      const day = today.getDay();
      const diffToMonday = (day + 6) % 7;
      const start = new Date(today);
      start.setDate(today.getDate() - diffToMonday);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      this.date_search = [
        start.toISOString().split('T')[0],
        end.toISOString().split('T')[0]
      ];
      await this.buildDaysFromRange();
    },
    async setNextWeek() {
      const today = new Date();
      const day = today.getDay();
      const diffToMonday = (day + 6) % 7;
      const startCurrentWeek = new Date(today);
      startCurrentWeek.setDate(today.getDate() - diffToMonday);
      const start = new Date(startCurrentWeek);
      start.setDate(startCurrentWeek.getDate() + 7);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      this.date_search = [
        start.toISOString().split('T')[0],
        end.toISOString().split('T')[0]
      ];
      await this.buildDaysFromRange();
    },
    resetRange() {
      this.date_search = [];
      this.selectedDays = [];
      this.centerCalendar = {};
      this.maxSlotsByDay = {};
    },
    async applyCustomRange() {
      if (!this.date_search[0] || !this.date_search[1]) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Seleziona data di inizio e di fine'
        });
        return;
      }
      this.menu_date_search = false;
      await this.buildDaysFromRange();
    },
    async buildDaysFromRange() {
      const start = new Date(this.date_search[0]);
      const end = new Date(this.date_search[1]);
      if (end < start) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore: La data di fine è antecedente alla data di inizio'
        });
        return;
      }
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      if (diffDays > 7) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Per la vista giornaliera selezionare un intervallo massimo di 7 giorni'
        });
        return;
      }
      const days = [];
      const cursor = new Date(start);
      while (cursor <= end) {
        days.push(cursor.toISOString().split('T')[0]);
        cursor.setDate(cursor.getDate() + 1);
      }
      this.selectedDays = days;
      await this.loadCenterCalendar();
    },

    // CARICAMENTO CALENDARIO
    async loadCenterCalendar() {
      if (!this.centerId || this.selectedDays.length === 0 || !this.activeFields.length) return;

      this.setLoading(true);

      // reset reattivo dello stato “macro”
      this.centerCalendar = {};
      this.maxSlotsByDay = {};

      for (let i = 0; i < this.activeFields.length; i++) {
        let field = this.activeFields[i];

        const daysNum = this.selectedDays.length;
        const result = await this.fetchCalendar({
          id: field._id,
          date: this.selectedDays[0],
          days: daysNum
        });

        if (!this.center) this.center = result.center;

        // merge dei dati del campo
        const mergedField = { ...field, ...result.field };
        this.$set(this.activeFields, i, mergedField);
        field = mergedField;

        // sport del campo
        const resultSports = (result.field.sports || []).map(s => ({
          _id: s._id,
          name: s.name,
          icon: s.icon || null
        }));
        if (resultSports.length) {
          this.$set(this.fieldSports, field._id, resultSports);
        }

        // selezione sport di default per campo
        if (!this.fieldSportSelection[field._id]) {
          let defaultSport = null;
          const fs = this.getFieldSports(field._id);

          if (fs.length === 1) {
            defaultSport = fs[0]._id;
          } else if (fs.length > 1 && this.sportFilter.length) {
            const match = fs.find(s => this.sportFilter.includes(s._id));
            defaultSport = match ? match._id : fs[0]._id;
          } else if (fs.length > 1) {
            defaultSport = fs[0]._id;
          }
          if (defaultSport) {
            this.$set(this.fieldSportSelection, field._id, defaultSport);
          }
        }

        // popolamento calendario per giorno
        Object.values(result.calendar.days).forEach(day => {
          const key = (new Date(day.date)).toISOString().split('T')[0];
          if (!this.selectedDays.includes(key)) return;

          if (!this.centerCalendar[key]) {
            this.$set(this.centerCalendar, key, {
              date: day.date,
              slotsByField: {}
            });
            this.$set(this.maxSlotsByDay, key, 0);
          }

          this.$set(this.centerCalendar[key].slotsByField, field._id, day.slots || []);

          const currentLen = (day.slots || []).length;
          if (currentLen > this.maxSlotsByDay[key]) {
            this.$set(this.maxSlotsByDay, key, currentLen);
          }
        });
      }

      this.setLoading(false);
    },

    getMaxSlotsForDay(dayKey) {
      return this.maxSlotsByDay[dayKey] || 0;
    },
    getSlot(dayKey, fieldId, index) {
      const day = this.centerCalendar[dayKey];
      if (!day || !day.slotsByField[fieldId]) return null;
      return day.slotsByField[fieldId][index] || null;
    },
    getFieldSports(fieldId) {
      return this.fieldSports[fieldId] || [];
    },
    getMaxSlotsForFieldAcrossDays(fieldId) {
      if (!fieldId) return 0;
      if (!this.centerCalendar || !this.selectedDays || !this.selectedDays.length) return 0;

      let max = 0;

      this.selectedDays.forEach(dayKey => {
        const key = String(dayKey);
        const day = this.centerCalendar[key];

        if (day && day.slotsByField && day.slotsByField[fieldId]) {
          const len = day.slotsByField[fieldId].length;
          if (len > max) {
            max = len;
          }
        }
      });

      return max;
    },

    // SLOT / BOOKING
    async bookNow(slot, slot_before = null, slot_after = null, dayKey, field) {
      if (slot.active && !slot.booked) {
        this.field = field;
        this.sports = this.getFieldSports(field._id);

        let slot_to_book = JSON.parse(JSON.stringify(slot));
        slot_to_book.prices.map((p) => {
          let ac = JSON.parse(JSON.stringify(p.value_ac));
          p.value_ce = (+p.value_ce) + (+ac);
          p.value_ac = 0;
        });

        slot_to_book.split_payment.online_percentage = 0;
        slot_to_book.split_payment.center_percentage = 100;
        slot_to_book.promo = null;
        slot_to_book.promo_sa = false;
        slot_to_book.promo_sa_global = false;
        slot_to_book.split_payment_custom = false;

        slot_to_book.center = this.center._id;
        slot_to_book.center_info = this.center;
        slot_to_book.field = field._id;
        slot_to_book.field_info = field;
        slot_to_book.sport_selected = this.fieldSportSelection[field._id] || null;
        slot_to_book.user = null;
        slot_to_book.note = '';

        if (field.half_hour_enabled) {
          slot_to_book.slot_before = slot_before || null;
          slot_to_book.slot_after = slot_after || null;
          slot_to_book.half_hour_enabled = true;
          slot_to_book.half_hour_price = JSON.parse(JSON.stringify(field.half_hour_price));
          slot_to_book.added_30_min_before = false;
          slot_to_book.added_30_min_after = false;
        } else {
          slot_to_book.slot_before = null;
          slot_to_book.slot_after = null;
          slot_to_book.half_hour_enabled = null;
          slot_to_book.half_hour_price = null;
          slot_to_book.added_30_min_before = false;
          slot_to_book.added_30_min_after = false;
        }

        await this.setBooking(slot_to_book);
        await this.setBookingOriginal(slot_to_book);
        await this.setDialogCheckout(true);
      } else {
        if (slot.booking_id) {
          this.$router.push('/bookings/edit/' + slot.booking_id);
        }
      }
    },

    async overrideSlot(dayKey, slot, field) {
      this.field = field;
      this.sports = this.getFieldSports(field._id);
      await this.fetchPromotions(field, dayKey);

      let find_promo = _.find(this.promotions_active, { 'slot_id': slot.slot_id });

      if (slot.promo_sa && !this.getUser.super_admin) {
        return;
      }

      this.override_title =
          this.formatDayTab(dayKey) + ' | ' + slot.start + ' - ' + slot.end + ' | ' + this.center.name + ' > ' + field.name;
      this.slot_selected = slot.slot_id;

      this.slot_to_override = {
        center_id: this.center._id,
        field_id: field._id,
        slot_id: slot.slot_id,
        date: new Date(dayKey).toISOString(),
        start_time: slot.start,
        end_time: slot.end,
        split_payment_custom: (slot.split_payment_custom) ? slot.split_payment_custom : false,
        split_payment: {
          online_percentage: (slot.split_payment && slot.split_payment.online_percentage) ? +slot.split_payment.online_percentage : 0.00,
          center_percentage: (slot.split_payment && slot.split_payment.center_percentage) ? +slot.split_payment.center_percentage : 0.00,
        },
        promo_custom: !!(slot.promo),
        promo_sa: (slot.promo_sa) ? slot.promo_sa : false,
        promo: {
          type: (slot.promo && slot.promo.type) ? slot.promo.type : '',
          value: (slot.promo && slot.promo.value) ? +slot.promo.value : 0.00,
        },
        status_slot: slot.active,
        id: '',
        slot_price: (slot.slot_price) ? slot.slot_price : null,
        enable_promo_code_promo_sa_global: (slot.enable_promo_code_promo_sa_global),
        enable_promo_code_promo_center: (slot.enable_promo_code_promo_center)
      };

      if (find_promo) {
        this.slot_to_override.id = find_promo._id;
        this.slot_to_override.enable_promo_code_promo_sa_global = (find_promo.enable_promo_code_promo_sa_global);
        this.slot_to_override.enable_promo_code_promo_center = (find_promo.enable_promo_code_promo_center);
      }

      this.preview_price = [];
      this.preview_price_override = [];
      this.sports.forEach((s) => {
        this.preview_price.push({
          sport_id: s._id,
          value_ac: 0.00,
          value_ce: 0.00,
          sport: s.name
        });
        this.preview_price_override.push({
          sport_id: s._id,
          value_ac: 0.00,
          value_ce: 0.00,
          sport: s.name
        });
      });

      await this.calculateTotalsOverride();
      this.dialog_promo = true;
    },

    async calculateTotalsOverride() {
      this.preview_price_override = JSON.parse(JSON.stringify(this.preview_price));
      this.preview_price_override.map((p) => {
        let prices = (this.slot_to_override.slot_price) ? this.slot_to_override.slot_price : this.field.price;
        let find = _.find(prices, { 'sport_id': p.sport_id });
        if (!find) return;
        let price = JSON.parse(JSON.stringify(find));

        if (this.slot_to_override.promo_custom) {
          if (this.slot_to_override.promo.type === 'fixed' && this.slot_to_override.promo.value >= 0.00) {
            price.value = +price.value - this.slot_to_override.promo.value;
          } else if (this.slot_to_override.promo.type === 'percentage' && this.slot_to_override.promo.value >= 0.00) {
            let discount_unit = _.round(+price.value / 100, 3);
            let discount = _.round(+discount_unit * (+this.slot_to_override.promo.value), 2);
            price.value = +price.value - discount;
          }
        }

        let online;
        let center;
        let unit = _.round(+price.value / 100, 3);
        if (this.slot_to_override.split_payment_custom) {
          online = _.round(+unit * (+this.slot_to_override.split_payment.online_percentage), 2);
          center = _.round(+unit * (+this.slot_to_override.split_payment.center_percentage), 2);
        } else {
          const master = this.field && this.field.split_payment_master
              ? this.field.split_payment_master
              : { online_percentage: 0, center_percentage: 100 };

          online = _.round(+unit * (+master.online_percentage || 0), 2);
          center = _.round(+unit * (+master.center_percentage || 0), 2);
        }

        p.value_ac = online;
        p.value_ce = center;
      });
    },

    async savePromotion() {
      if (this.slot_to_override.split_payment.online_percentage > 0 &&
          (!this.center.configurations ||
              (!this.center.configurations.paypal_enabled ||
                  this.center.configurations.paypal_client_id === '' ||
                  this.center.configurations.paypal_client_secret === ''))) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Non è possibile abilitare pagamenti online senza aver configurato correttamente un metodo di pagamento per il centro sportivo'
        });
        return;
      }
      await this.setLoading(true);
      let result = await this.storePromotion(this.slot_to_override);
      await this.setLoading(false);

      if (result.success) {
        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('createSuccess')
        });
        this.dialog_promo = false;
        await this.refresh();
      } else {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result)
        });
      }
    },

    async updatePromotion() {
      if (this.slot_to_override.split_payment.online_percentage > 0 &&
          (!this.center.configurations ||
              (!this.center.configurations.paypal_enabled ||
                  this.center.configurations.paypal_client_id === '' ||
                  this.center.configurations.paypal_client_secret === ''))) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Non è possibile abilitare pagamenti online senza aver configurato correttamente un metodo di pagamento per il centro sportivo'
        });
        return;
      }
      await this.setLoading(true);
      let result = await this.updatePromo({ id: this.slot_to_override.id, item: this.slot_to_override });
      await this.setLoading(false);

      if (result.success) {
        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        });
        this.dialog_promo = false;
        await this.refresh();
      } else {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result)
        });
      }
    },

    async deletePromotion() {
      await this.setLoading(true);
      let result = await this.deletePromo({ id: this.slot_to_override.id });
      await this.setLoading(false);

      if (result.success) {
        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('deleteSuccess')
        });
        this.dialog_promo = false;
        await this.refresh();
      } else {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result)
        });
      }
    },

    async fetchPromotions(field, dayKey) {
      let date = new Date(dayKey);
      date.setHours(0, 0, 0, 0);
      let promo = await this.getActivePromotions({ field_id: field._id, date: date.toISOString() });
      this.promotions_active = promo.result;
    },

    changePercentageOverride(type) {
      let total = 100.00;
      if (type === 'online') {
        if (+this.slot_to_override.split_payment.online_percentage < 0) {
          this.slot_to_override.split_payment.online_percentage = 0.00;
          this.slot_to_override.split_payment.center_percentage = 100.00;
        } else if (+this.slot_to_override.split_payment.online_percentage > 100) {
          this.slot_to_override.split_payment.online_percentage = 100.00;
          this.slot_to_override.split_payment.center_percentage = 0.00;
        } else {
          this.slot_to_override.split_payment.center_percentage =
              +(total - (+this.slot_to_override.split_payment.online_percentage));
        }
      } else if (type === 'center') {
        if (+this.slot_to_override.split_payment.center_percentage < 0) {
          this.slot_to_override.split_payment.center_percentage = 0.00;
          this.slot_to_override.split_payment.online_percentage = 100.00;
        } else if (+this.slot_to_override.split_payment.center_percentage > 100) {
          this.slot_to_override.split_payment.center_percentage = 100.00;
          this.slot_to_override.split_payment.online_percentage = 0.00;
        } else {
          this.slot_to_override.split_payment.online_percentage =
              +(total - (+this.slot_to_override.split_payment.center_percentage));
        }
      }
      this.calculateTotalsOverride();
      this.$forceUpdate();
    },

    applySplitOverride() {
      switch (this.split_payment_override_selected) {
        case "pay_divide": {
          this.slot_to_override.split_payment.online_percentage = 50.00;
          this.slot_to_override.split_payment.center_percentage = 50.00;
          this.calculateTotalsOverride();
          break;
        }
        case "pay_center": {
          this.slot_to_override.split_payment.online_percentage = 0.00;
          this.slot_to_override.split_payment.center_percentage = 100.00;
          this.calculateTotalsOverride();
          break;
        }
        case "pay_online": {
          this.slot_to_override.split_payment.online_percentage = 100.00;
          this.slot_to_override.split_payment.center_percentage = 0.00;
          this.calculateTotalsOverride();
          break;
        }
        default: {
          break;
        }
      }
    },

    changePromoCustom() {
      if (!this.slot_to_override.promo_custom) {
        this.slot_to_override.promo.type = '';
        this.slot_to_override.promo.value = 0;
        this.calculateTotalsOverride();
      }
    },

    getPrice(slot, fieldId, type = 'online') {
      const sportId = this.fieldSportSelection[fieldId] || this.sport_selected;
      if (!sportId) return 0;
      let find = _.find(slot.prices, { sport_id: sportId });
      if (!find) return 0;
      if (type === 'online') return find.value_ac;
      if (type === 'center') return find.value_ce;
      if (type === 'total') return find.value_ac + find.value_ce;
      return 0;
    },

    async refresh() {
      await this.loadCenterCalendar();
    },

    getAvailabilityNow(dayKey, id, field) {
      let parts = id.split(';');
      let split = parts[3].split(':');
      const now = new Date();
      now.setMinutes(now.getMinutes() + (field.rules ? field.rules.limit_time : 0));
      let day_obj = new Date(dayKey);
      day_obj.setHours(split[0], split[1], 0);
      return now <= day_obj;
    },

    formatDateHuman(my_date) {
      if (my_date) {
        let date = new Date(my_date);
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
      }
      return '';
    },

    formatDayTab(dayKey) {
      if (!dayKey) return '';
      const date = new Date(dayKey);
      const weekday = date.toLocaleDateString('it-IT', { weekday: 'long' });
      const day = String(date.getDate()).padStart(2, '0');
      const month = date.toLocaleDateString('it-IT', { month: 'long' });
      const w = weekday.charAt(0).toUpperCase() + weekday.slice(1);
      return `${w} ${day} ${month}`;
    },

    getSportName(_id) {
      let find = _.find(this.sports, { '_id': _id });
      if (find) return find.name;
      return _id;
    },

    removeText(text, text2) {
      if (!text) return '';
      return text.replace(text2, '');
    },
  }
};
</script>

<style scoped>
.field-col {
  width: 220px;
  max-width: 220px;
}

.sport-select {
  max-width: 180px;
  margin: 0 auto;
}

.calendar-full .time-slot {
  font-weight: 700;
  font-size: 13px;
  width: 100%;
  display: block;
  text-align: center;
}

.calendar-full .price {
  width: 100%;
  display: block;
  text-align: center;
  color: #00752a;
  font-size: 13px;
  font-weight: 600;
}

.calendar-full .price-promo {
  width: 100%;
  display: block;
  text-align: center;
  color: red;
  font-size: 13px;
  font-weight: 600;
}

.calendar-full .price-promo_sa {
  width: 100%;
  display: block;
  text-align: center;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
}

.calendar-full .label-pay {
  text-align: center;
  font-size: 10px;
  display: block;
  font-weight: 600;
  color: darkblue;
  text-transform: uppercase;
}

.calendar-full .btn-slot {
  padding: 0 8px;
  height: 60px;
  margin: 6px 0;
  border: none !important;
  cursor: pointer;
}

.calendar-full .btn-slot.promo_sa {
  background: #282b50 !important;
  color: #fff !important;
  animation: pulse 1.25s infinite ease-out;
}

.calendar-full .btn-slot.normal {
  background: #25a63936 !important;
}

.calendar-full .btn-slot.promo {
  background: rgb(40 43 80 / 10%) !important;
  animation: pulse-shadow 2s infinite;
}

.calendar-full .promo-amount {
  background: red;
  color: #fff;
  font-weight: 600;
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 3px;
  font-size: 13px;
  padding: 0 4px;
}

.calendar-full .label-pay-yellow {
  text-align: center;
  font-size: 10px;
  display: block;
  font-weight: 600;
  text-transform: uppercase;
  color: #baff3b;
}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
}

@keyframes blink-animation {
  to { visibility: hidden; }
}

@keyframes pulse {
  0% { transform: scale(1.0); }
  50% { transform: scale(1.15); }
  100% { transform: scale(1.0); }
}

@keyframes pulse-shadow {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 2px rgba(206, 67, 67, 0.48);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 0 rgba(206, 67, 67, 0.48);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 2px rgba(206, 67, 67, 0.48);
  }
}

.date-range-input .v-input__slot {
  background-color: #fafafa;
}

.quick-range-wrapper {
  gap: 4px;
}

.quick-range-btn {
  text-transform: none;
  min-width: 0;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
